import React from 'react'

import { useServiceOrder } from './_load/ServiceOrderLoader'
import Container from '../../../components/structure/Container'
import ExecutionForm from './ExecutionForm'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import FullPageMessage from '../../../components/presentation/FullPageMessage'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'
import Footer from './Footer'
import ImperativeComponents from '../../../containers/dynamic/form/replies/context/ImperativeComponentsContext'

const PageContent = () => {
  const serviceOrder = useServiceOrder()

  if (!serviceOrder)
    return (
      <FullPageMessage
        title="Essa atividade já foi respondida ou não existe"
        description="Uma atividade já respondida não pode ser editada por um link público. Verifique se o link está correto. Qualquer coisa entre em contato com o suporte."
        icon="BsFillXCircleFill"
        iconColor="red"
      />
    )

  return (
    <ImperativeComponents>
      <PageHeader />
      <Separator weight={4} />
      <FlexGrid align="stretch">
        <FlexCol flex={1} noMargin noRadius hideOn="mdd" />
        <Separator weight={4} vertical hideOn="mdd" />
        <FlexCol flex={4}>
          <Container maxWidth="52rem">
            <ExecutionForm />
            <Footer />
          </Container>
        </FlexCol>
        <Separator weight={4} vertical hideOn="mdd" />
        <FlexCol flex={1} noMargin noRadius hideOn="mdd" />
      </FlexGrid>
      <Separator weight={32} />
    </ImperativeComponents>
  )
}

export default PageContent
